import { provideAppInitializer, inject } from '@angular/core';
import { LoggerProviderService } from '../services/logger/logger.provider';

export const LoggerProvider = provideAppInitializer(() => {
  inject(LoggerProviderService);
});
